import { render, staticRenderFns } from "./TransactionsHistoryHeader.vue?vue&type=template&id=35ffdade&scoped=true&"
import script from "./TransactionsHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHistoryHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TransactionsHistoryHeader.vue?vue&type=style&index=1&id=35ffdade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffdade",
  null
  
)

export default component.exports